/* Existing layout/selector, live warehouse quantities. No shipping configuration. */
(function () {
  'use strict';
  var provinces = {
    NL: 'Newfoundland', PE: 'Prince Edward Island', NS: 'Nova Scotia',
    NB: 'New Brunswick', QC: 'Quebec', ON: 'Ontario', MB: 'Manitoba',
    SK: 'Saskatchewan', AB: 'Alberta', BC: 'British Columbia'
  };
  var core = {
    valid: function (value) { return Object.prototype.hasOwnProperty.call(provinces, value); },
    stripMarket: function (value) {
      return String(value || '')
        .replace(/(?:tag:)?["']?province:[a-z]+["']?(?:\s+OR\s+(?:tag:)?["']?province:[a-z]+["']?)*/gi, '')
        .replace(/\(\s*\)/g, '').replace(/\s+/g, ' ').trim();
    },
    visible: function (line) { return !!(line && line.known && (line.available > 0 || line.total === 0 || line.preorder)); },
    shoppingVisible: function (line) { return !!(line && line.known && line.allowed && (line.available > 0 || line.preorder)); },
    stockMessage: function (line, area) {
      if (!line || !line.known) return 'Delivery availability could not be verified. Please retry.';
      if (!line.allowed) return 'Not available for delivery in ' + area + '.';
      return line.preorder ? 'Preorder for ' + area + ' — not on-hand stock'
        : line.available + ' available for ' + area;
    },
    showAlternatives: function (line) { return !!(line && line.known && !line.allowed && !line.exempt); },
    alternativesURL: function (title, category) {
      var size = String(title || '').match(/\b(?:LT|P)?(\d{3})\/(\d{2})R(\d{2})\b/i);
      var query = size ? size.slice(1).join('') : 'tag:' + (category === 'wheel' ? 'wheel' : 'tire');
      return '/search?type=product&q=' + encodeURIComponent(query);
    },
    enough: function (lines) { return Array.isArray(lines) && lines.length > 0 && lines.every(function (line) { return line.allowed; }); }
  };
  core.projectedLines = projectedLines;
  if (typeof window === 'undefined') {
    if (typeof module !== 'undefined') module.exports = core;
    return;
  }
  core.batchSize = 250;
  window.TntProvinceStock = core;
  var config = document.querySelector('[data-tnt-province-api]');
  if (!config) return;
  var api = new URL(config.dataset.tntProvinceApi);
  var finderOrigins = (config.dataset.tntFinderOrigins || api.origin).split(' ');
  var originalFetch = window.fetch.bind(window);
  var province = null, generation = 0, timer, availabilityFailed = false;
  var persistDefault = false;
  var KEY = 'tnt_province';
  // TNT outage safety net (Oct 16 2026): when the Finder stock API itself is
  // down (network error / HTTP 5xx / 429 / 408), show products and let cart
  // actions through instead of hiding everything. Orders placed in that window
  // carry a cart attribute so stock can be verified by hand before fulfilling.
  var OUTAGE_NOTICE = 'Live stock check is temporarily unavailable. Products are shown and availability is confirmed when we process your order.';
  var OUTAGE_LABEL = 'Availability confirmed after order';
  var outageFlagged = false;
  function isOutage(error) { return !!(error && error.tntOutage); }
  function unverifiedText() {
    return 'UNVERIFIED - Finder stock API was down at ' + new Date().toISOString() + '. Confirm warehouse stock before fulfilling.';
  }
  function flagUnverified() {
    if (outageFlagged) return Promise.resolve();
    outageFlagged = true;
    return originalFetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { tnt_province: province || '', tnt_stock_check: unverifiedText() } })
    }).catch(function () {});
  }
  core.selectedProvince = function () { return province; };
  function readSaved() {
    try {
      var cookie = document.cookie.match(/(?:^|;\s*)tnt_province=([^;]*)/);
      return cookie ? decodeURIComponent(cookie[1]) : localStorage.getItem(KEY);
    } catch (_) { return null; }
  }
  province = core.valid(readSaved()) ? readSaved() : null;
  // A Finder search opens on another origin; carry its selected destination
  // separately from q, without relying on cross-origin cookie/localStorage.
  var requestedProvince = new URL(location.href).searchParams.get('province');
  if (core.valid(requestedProvince)) province = requestedProvince;
  // TNT (Oct 2026): first-time visitors used to see ZERO products until they picked a
  // province. ~80% of real buyers are in NL, so default to Newfoundland and let the
  // destination bar switch it. The choice persists like a manual selection would.
  var defaultProvince = (document.documentElement.getAttribute('data-tnt-default-province') || 'NL').toUpperCase();
  if (!province && core.valid(defaultProvince)) { province = defaultProvince; persistDefault = true; }
  function message(text) {
    var notice = document.getElementById('tnt-destination-notice');
    if (!notice) {
      notice = document.createElement('p'); notice.id = 'tnt-destination-notice';
      notice.setAttribute('role', 'status');
      document.body.prepend(notice);
    }
    notice.textContent = text;
  }
  function outageNotice() {
    var existing = document.getElementById('tnt-destination-notice');
    if (existing && existing.dataset.tntOutage === 'true') return;
    message(OUTAGE_NOTICE);
    var notice = document.getElementById('tnt-destination-notice');
    notice.dataset.tntOutage = 'true';
    var retry = document.createElement('button');
    retry.type = 'button'; retry.textContent = 'Retry availability';
    retry.addEventListener('click', function () { select(province); });
    notice.appendChild(retry);
  }
  function retryNotice(text) {
    availabilityFailed = true;
    message(text);
    var retry = document.createElement('button');
    retry.type = 'button'; retry.textContent = 'Retry availability';
    retry.addEventListener('click', function () { select(province); });
    document.getElementById('tnt-destination-notice').appendChild(retry);
  }
  function persist() {
    document.cookie = KEY + '=' + (province || '') + '; path=/; SameSite=Lax; max-age=' + (province ? 31536000 : 0);
    try { if (province) localStorage.setItem(KEY, province); else localStorage.removeItem(KEY); } catch (_) {}
  }
  if (persistDefault) { persist(); }
  function frames() {
    return Array.from(document.querySelectorAll('iframe')).filter(function (frame) {
      try { return finderOrigins.includes(new URL(frame.src).origin); } catch (_) { return false; }
    });
  }
  function publish() {
    frames().forEach(function (frame) {
      frame.contentWindow.postMessage({ type: 'tnt:setProvince', province: province }, new URL(frame.src).origin);
    });
    document.dispatchEvent(new CustomEvent('tnt:provinceChanged', { detail: { province: province } }));
  }
  function select(value) {
    province = core.valid(value) ? value : null;
    availabilityFailed = false;
    generation++; persist(); installSelector(); schedule();
    var selectedURL = new URL(location.href);
    if (selectedURL.searchParams.has('province') || selectedURL.pathname === '/search') {
      if (province) selectedURL.searchParams.set('province', province);
      else selectedURL.searchParams.delete('province');
      history.replaceState(history.state, '', selectedURL.toString());
    }
    document.querySelectorAll('[data-tnt-destination-variant]').forEach(function (node) {
      delete node.dataset.tntCheckedProvince;
      node.textContent = 'Checking selected-province availability…';
      var alternatives = node.closest('[data-tnt-product-availability]');
      var alternativeLink = alternatives && alternatives.querySelector('[data-tnt-area-alternatives]');
      if (alternativeLink) alternativeLink.hidden = true;
      var card = node.closest('.card-wrapper');
      if (card) {
        card.dataset.tntDestinationState = 'pending';
        (card.closest('.grid__item') || card).hidden = true;
        card.dataset.tntStockQty = '0';
        card.dataset.tntStockOk = 'false';
        card.dataset.tntStockKnown = 'false';
        card.dataset.tntDestinationPending = 'true';
        renderShippingPills(card, node, null);
      }
    });
    publish();
    updateCounts();
    // The homepage already has the shipping line. Keep routine destination
    // copy out of a second row above the navigation; real errors still surface.
    if (document.getElementById('tnt-province-trigger')) {
      var previousNotice = document.getElementById('tnt-destination-notice');
      if (previousNotice) previousNotice.remove();
    } else {
      message(province ? 'Availability for ' + provinces[province] + '. Shipping and delivery are confirmed at checkout.' : 'Choose a specific province to check availability.');
    }
    // Preserve cart quantities, but invalidate the prior province's approval.
    validateCart().catch(function (error) { message(error.message); });
  }
  function installSelector() {
    var dropdown = document.getElementById('tnt-province-dropdown');
    if (dropdown && !dropdown.dataset.tntTenProvinces) {
      dropdown.replaceChildren();
      Object.keys(provinces).forEach(function (code) {
        var button = document.createElement('button');
        button.type = 'button'; button.className = 'tnt-province-option';
        button.dataset.province = code; button.setAttribute('role', 'option');
        button.textContent = provinces[code]; dropdown.appendChild(button);
      });
      dropdown.dataset.tntTenProvinces = 'true';
    }
    var label = document.getElementById('tnt-province-label');
    if (label) label.textContent = provinces[province] || 'Choose province';
    if (!dropdown && !document.getElementById('tnt-destination-select')) {
      var bar = document.createElement('div');
      bar.className = 'tnt-destination-bar';
      var barInner = document.createElement('div');
      barInner.className = 'tnt-destination-bar__inner';
      var shippingLabel = document.createElement('label');
      shippingLabel.className = 'tnt-destination-bar__label';
      shippingLabel.htmlFor = 'tnt-destination-select';
      shippingLabel.innerHTML = '<svg class="tnt-destination-bar__icon" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 10c0 6-8 11-8 11S4 16 4 10a8 8 0 1 1 16 0Z"/><circle cx="12" cy="10" r="2.5"/></svg><span>Shipping to</span>';
      var selectNode = document.createElement('select'); selectNode.id = 'tnt-destination-select';
      selectNode.setAttribute('aria-label', 'Delivery province');
      selectNode.add(new Option('Choose province', ''));
      Object.keys(provinces).forEach(function (code) { selectNode.add(new Option(provinces[code], code)); });
      selectNode.addEventListener('change', function () { select(selectNode.value); });
      barInner.appendChild(shippingLabel);
      barInner.appendChild(selectNode);
      bar.appendChild(barInner);
      document.body.prepend(bar);
    }
    var compact = document.getElementById('tnt-destination-select');
    if (compact) compact.value = province || '';
    if (dropdown) {
      dropdown.querySelectorAll('[data-province]').forEach(function (option) {
        var active = option.dataset.province === province;
        option.setAttribute('aria-selected', String(active));
        option.classList.toggle('tnt-province-active', active);
        option.tabIndex = active ? 0 : -1;
      });
      var trigger = document.getElementById('tnt-province-trigger');
      if (trigger) {
        trigger.setAttribute('aria-label', 'Delivery province: ' + (provinces[province] || 'Choose province'));
        trigger.setAttribute('aria-controls', dropdown.id);
      }
    }
    var wrapper = document.getElementById('tnt-wrapper');
    if (wrapper) { wrapper.classList.remove('tnt-market-ca'); wrapper.classList.add('tnt-market-nl'); }
  }
  async function stock(items, checkOnly) {
    if (!province) throw new Error('Choose a specific province before adding tires or wheels.');
    var selected = province, version = generation, response, result;
    try {
      response = await originalFetch(new URL(checkOnly ? '/api/shopify/cart/validate' : '/api/shopify/stock', api), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ province: selected, items: items })
      });
    } catch (networkError) {
      var offline = new Error(OUTAGE_NOTICE); offline.tntOutage = true; throw offline;
    }
    try { result = await response.json(); } catch (parseError) { result = {}; }
    if (version !== generation || selected !== province) throw new Error('Province changed. Please check availability again.');
    if (response.status !== 409 && !response.ok) {
      var failure = new Error(result.error || 'Warehouse availability could not be checked.');
      failure.tntOutage = response.status >= 500 || response.status === 429 || response.status === 408;
      failure.tntStatus = response.status;
      throw failure;
    }
    if (checkOnly && !result.valid) throw new Error('Some cart quantities are unavailable for ' + provinces[province] + '. Adjust or remove those items before checkout.');
    return result;
  }
  async function cart() {
    var response = await originalFetch('/cart.js', { cache: 'no-store' });
    if (!response.ok) throw new Error('Your cart could not be checked.');
    return response.json();
  }
  function lines(current) {
    return current.items.filter(function (item) { return item.quantity > 0; }).map(function (item) {
      return { variantId: String(item.variant_id || item.id), quantity: item.quantity };
    });
  }
  async function validateCart() {
    var selected = province, version = generation;
    var current = await cart(), items = lines(current);
    if (!items.length) return;
    var unverified = false;
    try { await stock(items, true); } catch (error) { if (!isOutage(error)) throw error; unverified = true; }
    if (version !== generation) throw new Error('Province changed. Please check your cart again.');
    var attributes = { tnt_province: selected };
    if (unverified) attributes.tnt_stock_check = unverifiedText();
    var updated = await originalFetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    });
    if (!updated.ok) throw new Error('Your cart destination could not be saved.');
    if (version !== generation) throw new Error('Province changed. Please check your cart again.');
  }
  function projectedLines(current, path, data) {
    var projected = current.items.map(function (item) {
      return { variantId: String(item.variant_id || item.id), key: item.key, quantity: item.quantity };
    });
    if (/\/add(?:\.js|\.json)?$/.test(path)) {
      var added = data.items || [{ id: data.id, quantity: data.quantity || 1 }];
      added.forEach(function (item) {
        var quantity = Number(item.quantity || 1), id = String(item.id);
        if (!/^\d+$/.test(id) || !Number.isSafeInteger(quantity) || quantity < 1) throw new Error('Invalid cart quantity.');
        projected.push({ variantId: id, quantity: quantity });
      });
    } else if (/\/change(?:\.js|\.json)?$/.test(path)) {
      var index = data.line ? Number(data.line) - 1 : projected.findIndex(function (item) {
        return item.key === String(data.id) || item.variantId === String(data.id);
      });
      if (!projected[index]) throw new Error('The cart item changed. Please refresh your cart.');
      projected[index].quantity = Number(data.quantity);
    } else if (data.updates) {
      projected.forEach(function (item, index) {
        var value = Array.isArray(data.updates) ? data.updates[index] : data.updates[item.key] === undefined ? data.updates[item.variantId] : data.updates[item.key];
        if (value !== undefined) item.quantity = Number(value);
      });
    }
    if (projected.some(function (item) { return !Number.isSafeInteger(item.quantity) || item.quantity < 0; })) throw new Error('Invalid cart quantity.');
    return projected.filter(function (item) { return item.quantity > 0; }).map(function (item) {
      return { variantId: item.variantId, quantity: item.quantity };
    });
  }
  async function decodeBody(body) {
    if (body instanceof FormData) {
      var result = Object.fromEntries(body);
      var updates = body.getAll('updates[]');
      if (updates.length) result.updates = updates;
      return result;
    }
    if (typeof body === 'string') {
      try { return JSON.parse(body); } catch (_) {
        var params = new URLSearchParams(body), decoded = Object.fromEntries(params);
        if (params.getAll('updates[]').length) decoded.updates = params.getAll('updates[]');
        return decoded;
      }
    }
    if (body instanceof URLSearchParams) return Object.fromEntries(body);
    throw new Error('This cart request could not be verified. Please use the product page.');
  }
  // Cover Dawn/AJAX additions and quantity changes without changing their
  // successful response shape, levy hooks, properties, or selling plans.
  window.fetch = async function (input, init) {
    var url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
    var method = (init && init.method || input.method || 'GET').toUpperCase();
    if (url.origin === location.origin && method === 'POST' && /^\/(?:[a-z]{2}\/)?cart\/(?:add|change|update)(?:\.js|\.json)?$/.test(url.pathname)) {
      var body = init && init.body;
      if (body === undefined && input instanceof Request) body = await input.clone().text();
      var data = await decodeBody(body);
      if (Object.keys(data).some(function (key) { return /^(items|updates)\[/.test(key) && key !== 'updates[]'; })) {
        throw new Error('This nested cart request could not be verified. Please use the product page.');
      }
      // Attribute-only updates are not inventory mutations.
      if (/\/(?:add|change)(?:\.js|\.json)?$/.test(url.pathname) || data.id !== undefined || data.line !== undefined || data.items || data.updates) {
        var requested = projectedLines(await cart(), url.pathname, data);
        if (requested.length) {
          try { await stock(requested, true); } catch (error) {
            if (!isOutage(error)) throw error;
            var passthrough = await originalFetch(input, init);
            await flagUnverified();
            return passthrough;
          }
        }
      }
    }
    return originalFetch(input, init);
  };
  core.cardIsCurrent = function (card) {
    var marker = card.querySelector('[data-tnt-destination-variant]');
    return !!province && card.dataset.tntDestinationState === 'ready' &&
      !!marker && marker.dataset.tntCheckedProvince === province;
  };
  core.prepareCards = async function (cards) {
    var version = generation;
    var markers = cards.flatMap(function (card) { return Array.from(card.querySelectorAll('[data-tnt-destination-variant]')); });
    // A retry/new choice must also invalidate detached cached pages.
    markers.forEach(function (node) {
      if (node.dataset.tntCheckedGeneration !== String(version)) delete node.dataset.tntCheckedProvince;
    });
    await scan(markers);
    if (version !== generation) throw new Error('Province changed. Please check availability again.');
    return cards;
  };
  async function scan(inputMarkers) {
    if (!province) { updateCounts(); return; }
    var version = generation;
    var markers = (inputMarkers || Array.from(document.querySelectorAll('[data-tnt-destination-variant]'))).filter(function (node) {
      return node.dataset.tntCheckedProvince !== province;
    });
    for (var offset = 0; offset < markers.length; offset += batchSize) {
      // Up to 250 per Finder request; drops to 50 if the Finder still caps there.
      var batchSize = core.batchSize;
      var batch = markers.slice(offset, offset + batchSize), selected = province;
      var requestedIds = batch.map(function (node) { return node.dataset.tntDestinationVariant; });
      var unique = Array.from(new Set(requestedIds));
      var result;
      try {
        result = await stock(unique.map(function (variantId) {
          return { variantId: variantId, quantity: 1 };
        }), false);
        if (!Array.isArray(result.lines)) throw new Error('Invalid availability response.');
      } catch (error) {
        if (version !== generation) return;
        if (error.tntStatus === 400 && batchSize > 50 && unique.length > 50) {
          core.batchSize = 50; offset -= batchSize; continue;
        }
        if (isOutage(error)) {
          // Finder API itself is down: fail open so customers can still shop.
          batch.forEach(function (node) {
            node.textContent = OUTAGE_NOTICE;
            node.dataset.tntCheckedProvince = selected;
            node.dataset.tntCheckedGeneration = String(version);
            var card = node.closest('.card-wrapper');
            var container = card && (card.closest('.grid__item') || card);
            if (card) {
              container.hidden = false;
              card.dataset.tntDestinationState = 'ready';
              card.dataset.tntDestinationExempt = 'false';
              card.dataset.tntDestinationPending = 'false';
              card.dataset.tntStockKnown = 'false';
              card.dataset.tntStockOk = 'true';
              card.dataset.tntStockQty = '';
              card.dataset.tntStockBucket = '';
              card.dataset.tntSearchStock = 'unverified';
              renderCardStock(card, node, null);
              var label = card.querySelector('.tnt-card-stock');
              if (label) { label.textContent = OUTAGE_LABEL; label.setAttribute('aria-label', OUTAGE_NOTICE); }
              renderShippingPills(card, node, null);
            } else {
              node.hidden = false;
            }
            if (node.hasAttribute('data-tnt-product-stock')) {
              var form = document.querySelector('form[action*="/cart/add"]');
              var quantityInput = form && form.querySelector('[name="quantity"]');
              if (quantityInput) quantityInput.removeAttribute('max');
            }
          });
          outageNotice();
          continue;
        }
        batch.forEach(function (node) {
          node.textContent = 'Delivery availability could not be verified. Please retry.';
          node.dataset.tntCheckedProvince = selected;
          var card = node.closest('.card-wrapper');
          if (card) card.dataset.tntDestinationState = 'failed';
        });
        retryNotice('Delivery availability could not be verified. Unverified items are hidden.');
        continue;
      }
      batch.forEach(function (node, index) {
        if (node.dataset.tntDestinationVariant !== requestedIds[index]) return;
        var line = result.lines.find(function (entry) { return entry.variantId === node.dataset.tntDestinationVariant; });
        var card = node.closest('.card-wrapper'), container = card && (card.closest('.grid__item') || card);
        if (card) card.dataset.tntDestinationExempt = String(!!(line && line.exempt));
        if (line && line.exempt) {
          node.hidden = true; node.dataset.tntCheckedProvince = selected;
          node.dataset.tntCheckedGeneration = String(version);
          if (card) card.dataset.tntDestinationState = 'ready';
          return;
        }
        if (container) container.hidden = !core.shoppingVisible(line);
        if (card) card.dataset.tntDestinationState = !line || !line.known ? 'failed' : core.shoppingVisible(line) ? 'ready' : 'unavailable';
        if (card && line) {
          card.dataset.tntStockBucket = line.bucket || '';
          card.dataset.tntStockQty = String(line.available);
          card.dataset.tntStockKnown = String(line.known);
          card.dataset.tntStockPreorder = String(!!line.preorder);
          card.dataset.tntMountPearlAvailable = Number.isSafeInteger(line.mountPearlAvailable) ? String(line.mountPearlAvailable) : '';
          card.dataset.tntStockOk = String(line.preorder || line.available >= 4);
          card.dataset.tntSearchStock = line.available > 0 ? 'in-stock' : 'sold-out';
          card.dataset.tntDestinationPending = 'false';
        }
        if (!line || !line.known) retryNotice('Delivery availability could not be verified. Unverified items are hidden.');
        node.textContent = core.stockMessage(line, provinces[selected]);
        if (line && line.nationalNetwork && !card) node.textContent += ' · National partner network — availability depends on province';
        renderCardStock(card, node, line);
        if (node.hasAttribute('data-tnt-product-stock') && line) {
          var form = document.querySelector('form[action*="/cart/add"]'), quantityInput = form && form.querySelector('[name="quantity"]');
          if (quantityInput) {
            if (line.preorder || !line.known) quantityInput.removeAttribute('max');
            else quantityInput.max = String(line.available);
          }
          var panel = node.closest('[data-tnt-product-availability]');
          var alternativeLink = panel && panel.querySelector('[data-tnt-area-alternatives]');
          if (alternativeLink) {
            alternativeLink.hidden = !core.showAlternatives(line);
            alternativeLink.href = core.alternativesURL(panel.dataset.tntProductTitle, panel.dataset.tntProductCategory);
            alternativeLink.textContent = 'Find alternatives available in ' + provinces[selected];
          }
        }
        renderShippingPills(card, node, line);
        node.dataset.tntCheckedProvince = selected;
        node.dataset.tntCheckedGeneration = String(version);
      });
    }
    var grid = document.getElementById('product-grid');
    if (markers.length && grid && !window.__tntQuickResultsOwnGrid &&
        !(window.TntDestinationResults && window.TntDestinationResults.owns(grid))) {
      var cards = Array.from(grid.children).filter(function (item) { return item.querySelector('.card-wrapper'); });
      cards.sort(function (a, b) {
        function rank(item) {
          var wrapper = item.querySelector('.card-wrapper');
          return item.hidden ? 2 : wrapper.dataset.tntSearchStock === 'in-stock' ? 0 : 1;
        }
        return rank(a) - rank(b);
      }).forEach(function (item) { grid.appendChild(item); });
    }
    updateCounts();
  }
  function updateCounts() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    if (window.TntDestinationResults && window.TntDestinationResults.owns(grid)) return;
    var count = document.getElementById('tnt-destination-count');
    if (!count) {
      count = document.createElement('p'); count.id = 'tnt-destination-count';
      count.setAttribute('role', 'status'); grid.before(count);
    }
    var cards = Array.from(grid.querySelectorAll('.card-wrapper'));
    var visible = cards.filter(function (card) {
      return card.dataset.tntDestinationState === 'ready' && !card.closest('[hidden]') &&
        window.getComputedStyle(card).display !== 'none' &&
        (!card.closest('.grid__item') || window.getComputedStyle(card.closest('.grid__item')).display !== 'none');
    }).length;
    var pending = cards.some(function (card) { return !card.dataset.tntDestinationState || card.dataset.tntDestinationState === 'pending'; });
    var failed = availabilityFailed || cards.some(function (card) { return card.dataset.tntDestinationState === 'failed'; });
    var text = !province ? 'Choose a province to see available products.'
      : pending ? 'Checking selected-province availability…'
      : failed ? 'Some availability checks failed. Retry to see all eligible products on these pages.'
      : visible ? 'Available in ' + provinces[province]
      : 'No matches on this page for ' + provinces[province] + '. Try another page.';
    if (count.textContent !== text) count.textContent = text;
  }
  function renderCardStock(card, marker, line) {
    if (!card) return;
    marker.hidden = true;
    var label = card.querySelector('.tnt-card-stock');
    if (!label) {
      label = document.createElement('p');
      label.className = 'tnt-card-stock';
      var price = card.querySelector('.price');
      var information = price && price.closest('.card__information');
      (information || card.querySelector('.card-information') || card).appendChild(label);
    }
    label.textContent = !line || !line.known ? 'Check availability'
      : line.preorder ? 'Preorder'
      : core.shoppingVisible(line) ? line.available + ' available' : 'Unavailable here';
    label.setAttribute('aria-label', core.stockMessage(line, provinces[province]));
  }
  function renderShippingPills(card, marker, line) {
    var host = card && (card.querySelector('.card__inner') || card.querySelector('.card__media') || card);
    if (!host) return;
    var pills = host.querySelector('.tnt-shipping-areas');
    if (!pills) {
      pills = document.createElement('div');
      pills.className = 'tnt-shipping-areas';
      pills.setAttribute('role', 'group');
      pills.setAttribute('aria-label', 'Delivery areas based on available stock; shipping confirmed at checkout');
      host.appendChild(pills);
    }
    pills.replaceChildren();
    var codes = line && Array.isArray(line.shippingProvinces)
      ? Array.from(new Set(line.shippingProvinces.filter(core.valid))) : [];
    if (!line || !line.known || !Array.isArray(line.shippingProvinces) || !codes.length) {
      var fallback = document.createElement('span');
      fallback.className = 'tnt-shipping-pill tnt-shipping-pill--unknown';
      fallback.textContent = line && line.known && Array.isArray(line.shippingProvinces) ? 'Not available in your area' : 'Check delivery';
      pills.appendChild(fallback);
      return;
    }
    var eligible = codes.indexOf(province) !== -1;
    var details = document.createElement('details');
    details.className = 'tnt-shipping-summary';
    var summary = document.createElement('summary');
    summary.className = 'tnt-shipping-pill' + (eligible ? '' : ' tnt-shipping-pill--unknown');
    var label = document.createElement('strong');
    label.textContent = !core.valid(province) ? codes.length + ' delivery areas'
      : eligible ? (line.preorder || line.total === 0 ? 'Preorder ' : '') + province
      : 'Not available in your area';
    summary.appendChild(label);
    if (eligible && codes.length > 1) {
      var more = document.createElement('span');
      more.className = 'tnt-shipping-more';
      more.textContent = '+' + (codes.length - 1) + ' more';
      summary.appendChild(more);
    }
    summary.setAttribute('aria-label', summary.textContent + '. Show delivery areas');
    summary.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      details.open = !details.open;
    });
    details.addEventListener('click', function (event) { event.stopPropagation(); });
    details.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { details.open = false; summary.focus(); }
      event.stopPropagation();
    });
    var list = document.createElement('div');
    list.className = 'tnt-shipping-area-list';
    list.textContent = codes.map(function (code) { return provinces[code]; }).join(', ') +
      '. Shipping confirmed at checkout.';
    details.appendChild(summary);
    details.appendChild(list);
    pills.appendChild(details);
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(function () { scan().catch(function (error) { message(error.message); }); }, 150); }
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('#tnt-province-trigger');
    if (trigger) {
      event.preventDefault(); event.stopImmediatePropagation();
      setDropdown(trigger.getAttribute('aria-expanded') !== 'true', true);
      return;
    }
    var option = event.target.closest('.tnt-province-option[data-province]');
    if (option) {
      event.preventDefault(); event.stopImmediatePropagation(); select(option.dataset.province);
      setDropdown(false, true);
      return;
    }
    if (!event.target.closest('#tnt-province-dropdown')) setDropdown(false, false);
    var checkout = event.target.closest('[name="checkout"], a[href="/checkout"]');
    if (checkout) {
      event.preventDefault(); event.stopImmediatePropagation();
      validateCart().then(function () { location.assign('/checkout'); }).catch(function (error) { message(error.message); });
    }
  }, true);
  function setDropdown(open, focus) {
    var dropdown = document.getElementById('tnt-province-dropdown');
    var trigger = document.getElementById('tnt-province-trigger');
    if (!dropdown || !trigger) return;
    dropdown.classList.toggle('tnt-province-dropdown--open', open);
    trigger.setAttribute('aria-expanded', String(open));
    if (focus) {
      var target = open ? dropdown.querySelector('[aria-selected="true"]') || dropdown.querySelector('button') : trigger;
      if (target) target.focus();
    }
  }
  document.addEventListener('keydown', function (event) {
    if (!event.target.closest('#tnt-province-trigger, #tnt-province-dropdown')) return;
    if (event.key === 'Escape') { event.preventDefault(); setDropdown(false, true); return; }
    if (event.key === 'Tab') { setDropdown(false, false); return; }
    if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    var options = Array.from(document.querySelectorAll('#tnt-province-dropdown button'));
    var index = options.indexOf(document.activeElement);
    setDropdown(true, false);
    var next = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 :
      (index + (event.key === 'ArrowUp' ? -1 : 1) + options.length) % options.length;
    if (options[next]) options[next].focus();
  });
  document.addEventListener('tnt:resultsChanged', updateCounts);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form.action && new URL(form.action).origin === location.origin && new URL(form.action).pathname === '/search') {
      event.preventDefault(); event.stopImmediatePropagation();
      if (!province) { message('Choose a province before searching.'); return; }
      var params = new URLSearchParams(new FormData(form));
      params.set('q', core.stripMarket(params.get('q')));
      params.set('province', province);
      params.delete('page');
      location.assign('/search?' + params.toString());
      return;
    }
    if (form.action && /\/cart\/add$/.test(new URL(form.action).pathname)) {
      event.preventDefault(); event.stopImmediatePropagation();
      var body = new FormData(form);
      // Native TNT add-ons (road hazard warranty): checked boxes post as tnt_addon.
      // Shopify ignores that field, so add each one as its own line at the tire quantity.
      var addonIds = body.getAll('tnt_addon').filter(function (value) { return /^\d+$/.test(String(value)); });
      body.delete('tnt_addon');
      var addonPayload = null;
      decodeBody(body).then(function (data) {
        if (addonIds.length) {
          var addonQty = Math.max(1, Number(data.quantity) || 1);
          var mainItem = { id: Number(data.id), quantity: addonQty }, props = {};
          body.forEach(function (value, key) {
            var match = key.match(/^properties\[(.+)\]$/);
            if (match && value !== '') props[match[1]] = value;
          });
          if (Object.keys(props).length) mainItem.properties = props;
          if (data.selling_plan) mainItem.selling_plan = Number(data.selling_plan);
          var addedFor = document.title.replace(/ [\u2013-] .*$/, '');
          addonPayload = { items: [mainItem].concat(addonIds.map(function (id) {
            return { id: Number(id), quantity: addonQty, properties: { 'Added for': addedFor } };
          })) };
          data = addonPayload;
        }
        return cart().then(function (current) {
          return stock(projectedLines(current, '/cart/add', data), true).catch(function (error) {
            if (!isOutage(error)) throw error;
            return flagUnverified();
          });
        });
      }).then(function () {
        // Submit the original body (including existing properties/add-ons).
        if (addonPayload) {
          return originalFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(addonPayload) });
        }
        return originalFetch('/cart/add.js', { method: 'POST', body: body });
      }).then(function (response) {
        if (!response.ok) throw new Error('The item could not be added. Please refresh availability.');
        location.assign('/cart');
      }).catch(function (error) { message(error.message); });
    } else if (form.action && /\/cart$/.test(new URL(form.action).pathname) && event.submitter && event.submitter.name === 'checkout') {
      event.preventDefault(); event.stopImmediatePropagation();
      validateCart().then(function () { location.assign('/checkout'); }).catch(function (error) { message(error.message); });
    }
  }, true);
  window.addEventListener('message', function (event) {
    var frame = frames().find(function (entry) { return entry.contentWindow === event.source; });
    if (!frame || event.origin !== new URL(frame.src).origin || !event.data) return;
    if (event.data.type === 'tnt:requestProvince') publish();
    if (event.data.type === 'tnt:setProvince' && core.valid(event.data.province)) select(event.data.province);
  });
  window.addEventListener('storage', function (event) { if (event.key === KEY) select(event.newValue); });
  document.addEventListener('change', function (event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    var marker = document.querySelector('[data-tnt-product-stock]');
    var id = new FormData(form).get('id');
    if (marker && /^\d+$/.test(String(id))) {
      marker.dataset.tntDestinationVariant = String(id);
      delete marker.dataset.tntCheckedProvince; schedule();
    }
  });
  // Dawn's variant picker may sit outside the add-to-cart form. Read the
  // current hidden variant id after its own change handler has run, rather
  // than retaining the first variant's stock label.
  document.addEventListener('change', function (event) {
    if (!event.target.closest('variant-selects, variant-radios, [data-variant-picker]')) return;
    setTimeout(function () {
      var form = document.querySelector('form[action*="/cart/add"]');
      var marker = document.querySelector('[data-tnt-product-stock]');
      if (!form || !marker) return;
      var id = new FormData(form).get('id');
      if (!/^\d+$/.test(String(id)) || marker.dataset.tntDestinationVariant === String(id)) return;
      marker.dataset.tntDestinationVariant = String(id);
      delete marker.dataset.tntCheckedProvince;
      marker.textContent = 'Checking selected-variant availability…';
      schedule();
    }, 0);
  });
  function initialize() {
    var query = new URL(location.href), clean = core.stripMarket(query.searchParams.get('q'));
    if (query.pathname === '/search' && clean !== query.searchParams.get('q') && query.searchParams.has('q')) {
      query.searchParams.set('q', clean);
      if (province) query.searchParams.set('province', province);
      query.searchParams.delete('page');
      location.replace(query.toString()); return;
    }
    persist(); installSelector(); publish(); schedule();
    frames().forEach(function (frame) { frame.addEventListener('load', publish); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  new MutationObserver(function (records) {
    // Text/pill updates are not new products. Avoid repeatedly fetching when
    // a request is slow or failed, and still cover Dawn's AJAX pagination.
    if (records.some(function (record) {
      return Array.from(record.addedNodes).some(function (node) {
        return node.nodeType === 1 && (node.matches('[data-tnt-destination-variant], iframe') ||
          node.querySelector('[data-tnt-destination-variant], iframe'));
      });
    })) schedule();
  }).observe(document.documentElement, { subtree: true, childList: true });
  // No direct-checkout enforcement claim: address changes, direct URLs and
  // accelerated checkout require the external Shopify routing release gate.
})();
